import UserVerifyCode from './index';

export default { path: '/home/verifyCodeHistory', component: UserVerifyCode };
